// ============================================================
// TypeTemps — l'étiquette qui dit ce qu'on chronomètre.
// ------------------------------------------------------------
// Les mêmes trois mots que sur la fiche papier, et écrits pareil : la
// personne qui remplit le téléphone a la feuille imprimée sous les yeux.
// Deux vocabulaires pour la même chose obligeraient à traduire, debout,
// devant la machine.
//
// Pourquoi cette distinction se voit AVANT la saisie : un temps de
// montage se note une fois pour le lot, un temps de cycle se note pour
// UNE pièce. Confondre les deux fait entrer 50 fois le montage dans la
// mesure — et c'est précisément la mesure qui doit corriger le devis.
// ============================================================

const TYPES = {
  // Le vocabulaire COURANT. « Prototype » et « Production » sont les
  // deux lignes de chaque OP ; l'opérateur les a sous les yeux sur la
  // feuille imprimée, dans ces mots-là.
  // ── LES COULEURS NE CHANGENT PAS, ET C'EST VOULU ──
  //
  // Le JAUNE désignait le montage, le VERT le cycle machine. Ce sont les
  // deux mêmes natures de travail : le prototype EST du montage (plus la
  // programmation), la production EST du cycle. Changer la couleur en
  // même temps que le mot demanderait de réapprendre deux choses là où
  // une seule a bougé — et l'atelier a déjà des fiches imprimées.
  prototype: { texte: 'MISE EN ROUTE', classe: 'atelier__type--montage' },
  production: { texte: 'PRODUCTION', classe: 'atelier__type--cycle' },
  controle: { texte: 'CONTRÔLE', classe: 'atelier__type--prog' },
  // L'ANCIEN, pour les fiches déjà imprimées.
  cycle: { texte: 'CYCLE MACHINE', classe: 'atelier__type--cycle' },
  montage: { texte: 'MONTAGE', classe: 'atelier__type--montage' },
  programmation: { texte: 'PROGRAMMATION', classe: 'atelier__type--prog' },
};

/** Ce que l'opérateur doit comprendre : pour combien de pièces il note. */
const PORTEE = {
  par_piece: 'pour une pièce',
  par_lot: 'pour tout le lot',
  par_projet: 'une seule fois',
};

export function TypeTemps({ categorie, unite = null }) {
  // Une catégorie inconnue n'est pas silencieuse : elle s'affiche telle
  // quelle. Un badge muet cacherait une ligne de gamme mal formée.
  const t = TYPES[categorie] ?? { texte: String(categorie ?? '?'), classe: '' };
  return (
    <span className={`atelier__type ${t.classe}`}>
      {t.texte}
      {unite && PORTEE[unite] ? <em className="atelier__portee">{PORTEE[unite]}</em> : null}
    </span>
  );
}

export default TypeTemps;
